// Chart colors for the dark card surface (bg-secondaryBlack).
// Categorical and status palettes are validated for CVD separation
// and >= 3:1 contrast against CHART_SURFACE.

export const CHART_SURFACE = '#222223';

export const CHART_INK = {
  primary: '#f0efec',
  secondary: '#ACACAF',
  muted: '#898781',
  grid: '#333335',
  axis: '#4A4A4A',
};

export const STATUS_COLORS = {
  confirmed: '#0ca30c',
  pending: '#fab219',
  unanswered: '#8E8E93',
  declined: '#d03b3b',
};

export const SERIES_COLORS = [
  '#3987e5',
  '#d95926',
  '#199e70',
  '#c98500',
  '#d55181',
  '#008300',
];

// Players chart: one fixed color per player category.
export const PLAYER_COLORS = {
  regular: SERIES_COLORS[0],
  new: SERIES_COLORS[1],
  unregistered: SERIES_COLORS[2],
};

// Busy hours heatmap: black for free slots, then green -> yellow -> red
// for the busiest slots.
export const HEATMAP_EMPTY = '#0b0b0b';
export const HEATMAP_RAMP = [
  '#1f9d55',
  '#8cc63f',
  '#f2c230',
  '#f08c2e',
  '#e0413a',
];

export const WEATHER_COLORS = {
  temperature: SERIES_COLORS[1],
  rain: SERIES_COLORS[0],
};

export const WEEKEND_LINE_COLOR = 'rgba(240, 239, 236, 0.7)';

export const BAR_MAX_SIZE = 24;

// Fixed y-axis width so charts stacked under each other line up
export const Y_AXIS_WIDTH = 40;
